export const REPORTS_LIST = "SUPPLIERS_PORTAL_REPORTS_LIST";
export const REPORTS_CREATE = "SUPPLIERS_PORTAL_REPORTS_CREATE";
